// extracted by mini-css-extract-plugin
export default {"blockedButton":"CancelAssessmentAction_blockedButton__qa-wv","srOnly":"CancelAssessmentAction_srOnly__bRx9Y"};